import ActivatedDevicesSection from './activated-devices-section-container'
export default ActivatedDevicesSection
